import styled from 'styled-components';

const Header = styled.header`
  position: relative;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #e4e3e3;
  background: linear-gradient(to bottom, #e4e3e3 0%, #cccccc 100%);
  border-top: 1px solid #f3f5f4;
  border-bottom: 1px solid #959495;
  height: 55px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  padding: 4px 0 5px 8px;
`;

export default Header;
